import { Controller } from "@hotwired/stimulus"

// Provides save-button feedback: "Save" → "Saving..." → "Saved" → "Save"
// Usage:
//   <form data-controller="submit-feedback">
//     <button data-submit-feedback-target="button"
//             data-saving-text="Saving..."
//             data-saved-text="Saved"
//             data-action="turbo:submit-start->submit-feedback#submitStart">
//       Save changes
//     </button>
//   </form>
export default class extends Controller {
  static targets = ["button"]

  connect() {
    const key = `submit-feedback:${this.element.action}`
    if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key)
      this.showSaved()
    }
  }

  submitStart() {
    const btn = this.buttonTarget
    btn.disabled = true
    const original = btn.value || btn.textContent
    btn.dataset.originalText = original
    this.setText(btn, btn.dataset.savingText || "Saving...")
    btn.classList.add("opacity-70")
    sessionStorage.setItem(`submit-feedback:${this.element.action}`, "1")
  }

  showSaved() {
    const btn = this.buttonTarget
    const savedText = btn.dataset.savedText || "Saved"
    const originalText = btn.dataset.originalText || btn.value || btn.textContent
    this.setText(btn, savedText)
    btn.classList.add("opacity-70")
    setTimeout(() => {
      this.setText(btn, originalText)
      btn.classList.remove("opacity-70")
    }, 2000)
  }

  setText(btn, text) {
    if (btn.tagName === "INPUT") {
      btn.value = text
    } else {
      btn.textContent = text
    }
  }
}
